/**
 * Items app — /apps/items/*
 *
 * One job: one place to capture and manage the things that might matter.
 * Two screens: the list (capture, search, filter) and the item (edit, status).
 * All reads/writes go through the canonical items store — same rows every
 * other surface and app sees.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import ItemsListScreen from './ItemsListScreen';
import ItemDetailScreen from './ItemDetailScreen';

export default function ItemsApp() {
  const app = getAppDefinition('items')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<ItemsListScreen />} />
        <Route path=":itemId" element={<ItemDetailScreen />} />
        <Route path="*" element={<Navigate to="/apps/items" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
